<div class="container-fluid">
  <div class="sb-card pb-5">
    <div class="container flex-column d-flex justify-content-center align-items-center">
      <nav class="d-flex flex-column justify-content-center align-items-center py-5">
        <h4>New password</h4>
        <p class="sub-title">Please change your password</p>
      </nav>
      <form class="col-12 col-md-6" (ngSubmit)="changePass()" #resetPassForm="ngForm" aria-labelledby="title">
        <div class="form-control-group">
          <label class="label" for="input-password">New password:</label>
          <input nbInput [(ngModel)]="loginReq.password" #password="ngModel" type="password"
                 id="input-password" name="password" class="first" autofocus fullWidth fieldSize="large"
                 [status]="password.dirty ? (password.invalid  ? 'danger' : 'success') : 'basic'"
                 [required]="true" [minlength]="8" [maxlength]="20"
                 [attr.aria-invalid]="password.invalid && password.touched ? true : null">
          <ng-container *ngIf="password.invalid && password.touched">
            <p class="caption status-danger" *ngIf="password.errors?.required">
              Password is required!
            </p>
            <p class="caption status-danger" *ngIf="password.errors?.minlength || password.errors?.maxlength">
              Password should contains from 8 to 20 characters
            </p>
          </ng-container>
        </div>

        <div class="form-group mt-3">
          <label class="label" for="input-re-password">Confirm new password:</label>
          <input nbInput [(ngModel)]="loginReq.confirmPassword" #rePass="ngModel" id="input-re-password"
                 name="rePass" type="password" class="last" fullWidth fieldSize="large"
                 [status]="rePass.touched
                     ? (rePass.invalid || password.value != rePass.value ? 'danger' : 'success')
                     : 'basic'"
                 [required]="true" [attr.aria-invalid]="rePass.invalid && rePass.touched ? true : null">
          <ng-container *ngIf="rePass.touched">
            <p class="caption status-danger" *ngIf="rePass.invalid && rePass.errors?.required">
              Password confirmation is required!
            </p>
            <p class="caption status-danger" *ngIf="password.value != rePass.value && !rePass.errors?.required">
              Password does not match the confirm password.
            </p>
          </ng-container>
        </div>

        <button class="sb-button-primary"
                [disabled]="!resetPassForm.valid || submitted"
                [class.btn-pulse]="submitted">
          Proceed
        </button>
      </form>
      <p class="sb-text-primary mt-3" *ngIf="error">{{error}}</p>
    </div>
  </div>
</div>
